import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { LiAlignSkill } from './style'


export const SkillCard = ({ name, level }) => {

  return (
    <LiAlignSkill>
        <span><FontAwesomeIcon icon={faCheckCircle} /></span>
        <div>
          <span className='titleSpan'>{name}</span>
          <p>{level}</p>
        </div>
    </LiAlignSkill>
  )
}
